import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import { useNavigate, Link } from 'react-router-dom';
import { Toolbar, Typography, Box } from '@mui/material';

export default function NavBar() {
  const navigate = useNavigate();

  const handleLogOut = () => {
    window.localStorage.removeItem('token');
    navigate('/login');
    window.location.reload();
  };

  return (

    <AppBar sx={{backgroundColor:'#212529',width:'100%',px:'30px'}}>
      <Toolbar sx={{ minHeight: '48px !important',justifyContent:'space-between'}}>
        <Typography variant="h4">
          Artify
        </Typography>
        <Button variant='contained' onClick={handleLogOut} sx={{color:'white', backgroundColor:'transparent', border:'1px solid transparent','&:hover': {borderColor:'#fff', backgroundColor:'transparent'}}}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>

  );
}
